import { render, staticRenderFns } from "./FormItemGroup.vue?vue&type=template&id=4a6d1cab&scoped=true"
import script from "./FormItemGroup.vue?vue&type=script&lang=js"
export * from "./FormItemGroup.vue?vue&type=script&lang=js"
import style0 from "./FormItemGroup.vue?vue&type=style&index=0&id=4a6d1cab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d1cab",
  null
  
)

export default component.exports